import { CheckMarkIcon, ErrorIcon } from '@/components/common/Icons';
import { useAppSelector } from '@/state/hooks';
import { Notification } from '@/state/reducers/notificationSlice';
import { selectGeneralSettings } from '@/state/reducers/settingSlice';
import { formatNotification, formatUTCNotification } from '@/utils/format';
import { useSso } from '@/utils/providers/SSOProvider';
import cn from 'classnames';
import { Fragment, useMemo } from 'react';
import { BsInfoCircle } from 'react-icons/bs';
import { MdLink } from 'react-icons/md';

interface NotificationsMainProps {
    notification: Notification;
}

const Notifications = {
    Accent: ({ notification }: NotificationsMainProps) => (
        <div className="mt-1 flex flex-col items-center gap-2">
            <Notifications.Icon type={notification.type} />
            {notification.isPartOfOcoOrder && <MdLink className={cn('rotate-90')} aria-hidden />}
        </div>
    ),
    Stamp: ({ notification }: NotificationsMainProps) => {
        const { entities } = useSso();

        const generalSettings = useAppSelector(selectGeneralSettings);
        const { created_at, account } = notification;

        const gcexAccountName = useMemo(() => {
            if (entities) {
                return (
                    entities.find(
                        (entity) =>
                            entity.nameMappings?.find((nameMapping) => nameMapping.source === 'CELER')?.name === account
                    )?.entityName || account
                );
            } else return account;
        }, [entities, account]);

        return (
            <Fragment>
                <span>
                    {generalSettings.timezone.value === 'UTC'
                        ? formatUTCNotification(created_at)
                        : formatNotification(created_at)}{' '}
                    ( {generalSettings.timezone.label.replace(' Timezone', '')} )
                </span>
                {(gcexAccountName || account) && (
                    <span className="text-xs mt-auto leading-5 lg:leading-6">{gcexAccountName || account}</span>
                )}
            </Fragment>
        );
    },
    Icon: ({ type }: any) => {
        switch (type) {
            case 'info':
                return <BsInfoCircle />;
            case 'success':
                return <CheckMarkIcon />;
            case 'error':
                return <ErrorIcon />;
            default:
                return <CheckMarkIcon />;
        }
    }
};

export default Notifications;
